<template>
	<nav class="o-container c-navigation">
		<div class="o-layout o-layout--spacing-large">
			<div class="o-layout__item u-10/12 u-offset-1/12 u-background-purple">
				<div class="o-box o-box--spacing-small u-padding-horzontal-none u-type-white">
					<ul class="o-list-inline o-list-inline--spacing-reduced o-list-inline--delimited-pipe">
						<li class="o-list-inline__item c-type-beta" v-for="link in links">
							<router-link :to="link.path" v-if="externalPath(link)">{{link.name}}</router-link>
							<a v-else :href="link.path">{{link.name}}</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	name: 'navigation',
	data () {
		return {
			links: [
				{
					name: 'Posts',
					path: '/'
				},
				{
					name: 'Vue',
					path: 'https://vuejs.org'
				},
				{
					name: 'WP API',
					path: 'https://developer.wordpress.org/rest-api/'
				},
				{
					name: 'Twitter',
					path: 'http://www.twitter.com/webdevluke'
				}
			]
		}
	},
	methods: {
		// Returns true if path contains "http", used to figure out if we're dealing with an external link
		externalPath: function(link) {
			return link.path.indexOf('http') === -1
		}
	}
}
</script>


// WEBPACK FOOTER //
// navigation.vue?70895869